import client from '../config/AxiosConfig';

export const GetWeddingCanvaOptions = async (id) => client.get(`/weddingCanva/${id}/options`);

export const CreateWeddingCanva = async (data) =>
  client.post(`/weddingCanva`, data);

export const UpdateWeddingCanva = async (id, data, type) =>
  client.put(`/weddingCanva/${id}/${type}`, data);

export const GetWeddingCanvas = async (currentPage, limit, filters = {}) =>
  client.get(`/weddingCanva/${currentPage}/${limit}?filter=${JSON.stringify(filters)}`);

export const RenderWeddingCanva = async (id) =>
  client.get(`/weddingCanva/${id}/render`);

export const SoftDeleteWeddingCanva = async id =>
  client.put(`/weddingCanva/softDelete/${id}`);

export const GetWeddingCanvaColors = async (weddingId, section) =>
  client.get(`/weddingCanva/${weddingId}/${section}/colors`);

export const SaveWeddingCanvaColors = async (answerId, data) =>
  client.put(`/weddingCanva/${answerId}/colors`, data);

export const ValidateWeddingCanvaSubmission = async (canvaId) =>
  client.get(`/weddingCanva/${canvaId}/submit/validate`);

export const SubmitFinalWeddingCanva = async (canvaId, data) =>
  client.put(`/weddingCanva/${canvaId}/submit`, data);

export const ApproveFinalWeddingCanva = async (canvaId) =>
  client.put(`/weddingCanva/${canvaId}/approve`);

export const ReproveFinalWeddingCanva = async (canvaId) =>
  client.put(`/weddingCanva/${canvaId}/reprove`);

export const AutoSelectCanvaOptions = async (canvaId) =>
  client.put(`/weddingCanva/${canvaId}/auto-select-options`);